import React from "react";
import styled from "styled-components";
import breakpoint from "../../../../../../utils/breakpoint";
import space from "../../../../../../utils/space";
import { breakpointValue } from "../../settings";
var linkVerticalPaddingSpace = 1.5;
var Links = styled.ul.withConfig({
  componentId: "sc-7ls9so-0"
})(["margin-bottom:", ";&:first-child{margin-top:", ";}&:last-child{margin-bottom:", ";}> li{position:relative;margin-bottom:", ";padding:", " 0;&:last-child{margin-bottom:0;}", "{margin-bottom:", ";}}"], space(6 - linkVerticalPaddingSpace), space(-1 * linkVerticalPaddingSpace), space(-1 * linkVerticalPaddingSpace), space(4 - 2 * linkVerticalPaddingSpace), space(linkVerticalPaddingSpace), breakpoint(breakpointValue), space(3 - 2 * linkVerticalPaddingSpace));
var AdditionalLink = styled.div.withConfig({
  componentId: "sc-7ls9so-1"
})(["position:relative;margin:", " 0;padding:", " 0;"], space(-1 * linkVerticalPaddingSpace), space(linkVerticalPaddingSpace));
function DropdownLinksOrg(_ref) {
  var links = _ref.links,
    additionalLink = _ref.additionalLink;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Links, null, links.map(function (link, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        key: index
      }, link)
    );
  })), additionalLink ? /*#__PURE__*/React.createElement(AdditionalLink, null, additionalLink) : null);
}
export default DropdownLinksOrg;